/**
 * FodindinAir-Bengue : rubrique des prestations à l'étranger.
 * Les tarifs d'abonnement sont ceux du Club VIP ; les numéros sont réservés
 * aux abonnés premium de cette rubrique.
 */
export const AIR_BENGUE = {
  id: "air",
  name: "FodindinAir-Bengue",
  court: "Air-Bengue",
  route: "/air-bengue",
  tagline: "Le Bengué à portée de main",
  description:
    "Les annonceurs installés hors de Côte d'Ivoire : massages, accompagnement et prestations à domicile, de Bruxelles à Montréal.",
  color: "#4C6EF5",
  colorSoft: "rgba(76,110,245,0.14)",
};

export const TYPES_AIR = [
  { id: "tous", label: "Tous les services" },
  { id: "massage", label: "Massage" },
  { id: "escorte", label: "Accompagnement privé" },
  { id: "accompagnement", label: "Sorties & événements" },
  { id: "domicile", label: "Prestation à domicile" },
  { id: "autre", label: "Autre" },
];

export const PAYS_BENGUE = [
  "Belgique", "France", "Suisse", "Canada", "Allemagne", "Italie", "Espagne",
  "Royaume-Uni", "Pays-Bas", "États-Unis", "Maroc", "Tunisie", "Sénégal",
  "Émirats arabes unis", "Autre",
];

export const libelleType = (id) =>
  TYPES_AIR.find((t) => t.id === id)?.label || "Autre";
